import { NgModule } from '@angular/core';
import { EventsComponent } from './events.component';
import { MATERIALS } from '../../../../app.materials';
import { BaseModule } from '../../../../shared/base.module';
import { EventsRoutesModule } from './events.routes';
import { B2CAdminDashboardFiltersModule } from '../filters/b2c-admin-filters.module';
import { PaginationModule } from '../../../../shared/pagination/pagination.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        PaginationModule,
        EventsRoutesModule,
        TooltipModule,
        B2CAdminDashboardFiltersModule
    ],
    declarations: [
        EventsComponent
    ],
    exports: [
        EventsComponent
    ],
    providers: [
    ]
})
export class EventsModule {
}
